import { useDisclosure } from "@mantine/hooks";
import { useMemo, useState } from "react";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { PageContainer } from "src/styled";

import type {
  actionType,
  ITankPlan,
} from "../../../../components/pages/Settings/YachtSetUp/TankPlans/tankPlans.model";
import TankPlansAddModal from "../../../../components/pages/Settings/YachtSetUp/TankPlans/TankPlansAddModal";
import TankPlansTable from "../../../../components/pages/Settings/YachtSetUp/TankPlans/TankPlansTable/TankPlansTable";
import { Button } from "../../../../components/shared/Button/Button";
import HistoryModal from "../../../../components/shared/HistoryModal/HistoryModal";
import { useGetApi } from "../../../../hooks";
import { ButtonWrapper } from "../../AccountDetails/AccountDetails.styled";
import { getYachtId } from "src/utils";

const TankPlans = () => {
  const yachtid = getYachtId();
  const [addModalOpened, { open: openAddModal, close: closeAddModal }] =
    useDisclosure(false);

  const [
    historyModalOpened,
    { open: openHistoryModal, close: closeHistoryModal },
  ] = useDisclosure(false);

  const [selectedRow, setSelectedRow] = useState<ITankPlan | undefined>();
  const [tableSortedData, setTableSortedData] = useState<ITankPlan[]>([]);
  const { data, refetch } = useGetApi<{ list: ITankPlan[] }>({
    request: "get-tanks",
    // mapper: data => data?.list ?? [],
  });
  const handleAction = (action: actionType, rowIdx: number) => {
    if (!tableSortedData.length) return;
    setSelectedRow(tableSortedData[rowIdx]);
    if (action === "history") openHistoryModal();
    else openAddModal();
  };

  const handleClose = (action: actionType) => {
    setSelectedRow(undefined);
    if (action === "history") closeHistoryModal();
    else closeAddModal();
  };

  const sortedData = useMemo(
    () => (data?.list ? data.list.sort((a, b) => a.order - b.order) : []),
    [data],
  );
  return (
    <PageContainer>
      <Breadcrumbs border={false}>
        <ButtonWrapper style={{ gap: 12 }}>
          <Button variant="outline" onClick={openHistoryModal}>
            History
          </Button>
          <Button variant="outline" onClick={openAddModal}>
            Add+
          </Button>
        </ButtonWrapper>
      </Breadcrumbs>
      {sortedData.length > 0 && (
        <TankPlansTable
          onAction={handleAction}
          data={sortedData}
          refetch={refetch}
          onSortedDataChange={setTableSortedData}
        />
      )}
      <TankPlansAddModal
        opened={addModalOpened}
        close={() => handleClose("add")}
        refetch={refetch}
        values={selectedRow}
      />

      <HistoryModal
        opened={historyModalOpened}
        close={() => handleClose("history")}
        elementName={selectedRow?.name}
        dataHeaders={["Tank Name"]}
        dataKeys={["name"]}
        size="55vw"
        params={{
          ...(selectedRow?.tankid
            ? { tankid: selectedRow?.tankid }
            : { yachtid, full: true }),
        }}
        apiUrl="get-tanks-history"
      />
    </PageContainer>
  );
};

export default TankPlans;
